import Reveal from '../../components/Reveal/Reveal';
import { BRAND_PRINCIPLES, LOGO, SITE } from '../../app.const';

function About() {
  return (
    <div className="About">
      <p className="Eyebrow">About</p>
      {/* <h1>{SITE.name}</h1> */}

      <Reveal className="About-brandmark">
        <img src={LOGO.full.src} alt={LOGO.full.alt} />
      </Reveal>

      <Reveal as="section" className="About-section">
        <p className="Eyebrow">Mission</p>
        <p>{SITE.mission}</p>
      </Reveal>

      <Reveal as="section" className="About-section">
        <p className="Eyebrow">Vision</p>
        <p>{SITE.vision}</p>
      </Reveal>

      <Reveal as="section" className="About-section u-promise">
        <p>{SITE.promise}</p>
      </Reveal>

      <Reveal as="section" className="About-section">
        <p className="Eyebrow">Principles</p>
        <div className="Editorial-list">
          {BRAND_PRINCIPLES.map((principle, index) => (
            <div className="Editorial-item" key={principle.id}>
              <span className="Editorial-index">{String(index + 1).padStart(2, '0')}</span>
              <div className="Editorial-content">
                <h3>{principle.title}</h3>
                <p>{principle.description}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  );
}

export default About;
